import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";

export const LotDetailsModal = ({ open, onClose, lot }) => {
  if (!lot) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{lot.name}</DialogTitle>

      <DialogContent dividers>
        <Box mb={2}>
          <Typography variant="subtitle2" color="text.secondary">
            {lot.number} — {lot.trade}
          </Typography>
        </Box>

        <Typography>
          <strong>Описание:</strong>
        </Typography>
        <Typography paragraph>{lot.description || "Нет описания"}</Typography>

        <Typography>
          <strong>Заказчик:</strong> {lot.customer}
        </Typography>
        <Typography>
          <strong>Регион:</strong> {lot.locality}
        </Typography>

        <Box mt={2}>
          <Typography>
            <strong>Цена за единицу:</strong> {lot.unitPrice ?? "—"} ₸
          </Typography>
          <Typography>
            <strong>Количество:</strong> {lot.count ?? "—"} {lot.measure}
          </Typography>
          <Typography>
            <strong>Сумма:</strong> {lot.amount ?? "—"} ₸
          </Typography>
        </Box>

        <Box mt={2}>
          <Typography>
            <strong>Дата начала:</strong> {lot.dateOfStart}
          </Typography>
          <Typography>
            <strong>Дата окончания:</strong> {lot.dateOfEnd}
          </Typography>
        </Box>

        <Box mt={2}>
          {lot.analyzedByUser && (
            <Typography color="success.main">
              🧠 Анализ уже выполнялся
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
